import { DocsBlockPropertyDefinition, } from "./SDKDocsBlockProperty";
/** Url property - Definition */
export class DocsBlockUrlPropertyDefinition extends DocsBlockPropertyDefinition {
}
